'use client';

import { IconSearch } from '@tabler/icons-react';

interface HeaderSearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  ariaLabel: string;
}

export function HeaderSearchInput({
  value,
  onChange,
  placeholder,
  ariaLabel,
}: HeaderSearchInputProps) {
  return (
    <div className="relative w-full">
      <IconSearch className="absolute left-3 top-1/2 -translate-y-1/2 size-4 text-muted-foreground pointer-events-none" />
      <input
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="w-full h-9 pl-9 pr-3 text-sm rounded-md border border-input bg-background shadow-sm focus:outline-none focus:ring-2 focus:ring-ring"
        aria-label={ariaLabel}
      />
    </div>
  );
}
